import { Component, OnInit, NgZone, } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { AuthservicesService } from '../../../../services/authservices.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-create-ticket',
  templateUrl: './create-ticket.component.html',
  styleUrls: ['./create-ticket.component.css']
})
export class CreateTicketComponent implements OnInit {
  form: FormGroup;
  submitted = false
  errorMessage
  tickets
  loading = false

  constructor(private authService: AuthservicesService, private fb: FormBuilder, private router: Router) { }

  ngOnInit(): void {
    this.errorMessage = environment.errorMessage

    this.tickets = environment.tickets
    this.form = this.fb.group({
      description: ['', Validators.required],
      title: ['', Validators.required],

    })
  }


  get f() {
    return this.form.controls;
  }


  onSubmit() {

    // this.submitted = true;
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }
    this.authService.addSupport(this.form.value).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success')
      this.router.navigate(['/support'])
    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }


}



